(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-image-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('video-slider-section')) {
    class VideoSliderSection extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        if (!this.track) return;

        this.nav = this.querySelector('[data-nav]');
        this.dotsEl = this.querySelector('[data-dots]');
        this.prevBtn = this.querySelector('[data-prev]');
        this.nextBtn = this.querySelector('[data-next]');
        this.cards = Array.from(this.track.querySelectorAll('[data-card]'));
        this.videoCards = this.cards.filter((c) => c.querySelector('video'));

        const d = this.dataset;
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.opts = {
          autoplayVideo: d.autoplayVideo === 'true' && !this.reduce,
          keepSound: d.keepSound === 'true',
          exclusive: d.exclusive === 'true',
          tapRipple: d.ripple === 'tap' || d.ripple === 'both',
          sliderAutoplay: d.sliderAutoplay === 'true' && !this.reduce && this.cards.length > 1,
          delay: Math.max(parseInt(d.delay, 10) || 4000, 2000)
        };

        this.soundOn = d.startMuted === 'false';
        this.visible = new Set();
        this.userPaused = new Set();
        this.activeCard = null;
        this.timer = null;
        this.sliderInView = true;
        this.userControl = false;

        this.initVideos();
        this.buildDots();
        this.bindEvents();
        this.update();
        this.initSliderAutoplay();
      }

      disconnectedCallback() {
        this.stopSliderAutoplay();
        ['io', 'preloadIO', 'resizeObserver', 'viewObserver'].forEach((k) => this[k] && this[k].disconnect());
        if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
      }

      /* ---------- Slider ---------- */
      get pad() {
        return parseFloat(getComputedStyle(this.track).paddingLeft) || 0;
      }

      buildDots() {
        if (!this.dotsEl) return;
        this.dotsEl.innerHTML = '';
        this.dots = this.cards.map((_, i) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'vs-dot';
          dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          dot.addEventListener('click', () => this.goTo(i));
          this.dotsEl.appendChild(dot);
          return dot;
        });
      }

      goTo(index) {
        const card = this.cards[index];
        if (!card) return;
        this.track.scrollTo({ left: card.offsetLeft - this.pad, behavior: this.reduce ? 'auto' : 'smooth' });
      }

      isAtEnd() {
        return this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 4;
      }

      update() {
        const scrollable = this.track.scrollWidth - this.track.clientWidth > 8;
        if (this.nav) this.nav.hidden = !scrollable;

        const left = this.track.scrollLeft;
        const pad = this.pad;
        let idx = 0;
        if (scrollable && this.isAtEnd()) {
          idx = this.cards.length - 1;
        } else {
          let best = Infinity;
          this.cards.forEach((card, i) => {
            const dist = Math.abs(card.offsetLeft - pad - left);
            if (dist < best) {
              best = dist;
              idx = i;
            }
          });
        }
        this.current = idx;
        if (this.dots) this.dots.forEach((dot, i) => dot.setAttribute('aria-current', i === idx ? 'true' : 'false'));
        if (this.prevBtn) this.prevBtn.disabled = idx === 0;
        if (this.nextBtn) this.nextBtn.disabled = idx === this.cards.length - 1;
      }

      bindEvents() {
        let ticking = false;
        this.track.addEventListener(
          'scroll',
          () => {
            if (ticking) return;
            ticking = true;
            requestAnimationFrame(() => {
              this.update();
              ticking = false;
            });
          },
          { passive: true }
        );

        this.prevBtn?.addEventListener('click', () => this.goTo(Math.max(this.current - 1, 0)));
        this.nextBtn?.addEventListener('click', () => this.goTo(Math.min(this.current + 1, this.cards.length - 1)));

        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this.track);

        this.addEventListener('click', (e) => this.onClick(e));
      }

      /* ---------- Slider autoplay ---------- */
      initSliderAutoplay() {
        if (!this.opts.sliderAutoplay) return;

        ['pointerenter', 'focusin', 'touchstart'].forEach((evt) =>
          this.addEventListener(evt, () => this.stopSliderAutoplay(), { passive: true })
        );
        ['pointerleave', 'focusout', 'touchend'].forEach((evt) =>
          this.addEventListener(evt, () => this.restartSliderAutoplay(), { passive: true })
        );

        this.onVisibility = () => (document.hidden ? this.stopSliderAutoplay() : this.restartSliderAutoplay());
        document.addEventListener('visibilitychange', this.onVisibility);

        this.viewObserver = new IntersectionObserver(
          ([entry]) => {
            this.sliderInView = entry.isIntersecting;
            this.sliderInView ? this.restartSliderAutoplay() : this.stopSliderAutoplay();
          },
          { threshold: 0.3 }
        );
        this.viewObserver.observe(this);
        this.startSliderAutoplay();
      }

      startSliderAutoplay() {
        if (!this.opts.sliderAutoplay || this.timer || !this.sliderInView || this.userControl) return;
        this.timer = setInterval(() => {
          this.isAtEnd() ? this.goTo(0) : this.goTo(this.current + 1);
        }, this.opts.delay);
      }

      stopSliderAutoplay() {
        clearInterval(this.timer);
        this.timer = null;
      }

      restartSliderAutoplay() {
        this.stopSliderAutoplay();
        this.startSliderAutoplay();
      }

      /* ---------- Videos ---------- */
      initVideos() {
        if (!this.videoCards.length) return;

        this.videoCards.forEach((card) => {
          const v = card.querySelector('video');
          card._v = v;
          v.muted = !this.soundOn;
          this.setState(card);
          ['play', 'pause', 'ended', 'volumechange'].forEach((evt) => v.addEventListener(evt, () => this.setState(card)));
        });

        this.io = new IntersectionObserver(
          (entries) => {
            entries.forEach((en) => {
              en.intersectionRatio >= 0.5 ? this.visible.add(en.target) : this.visible.delete(en.target);
            });
            this.sync();
          },
          { threshold: [0, 0.5] }
        );
        this.preloadIO = new IntersectionObserver(
          (entries) => {
            entries.forEach((en) => {
              if (!en.isIntersecting) return;
              en.target._v.preload = 'metadata';
              this.preloadIO.unobserve(en.target);
            });
          },
          { rootMargin: '300px' }
        );
        this.videoCards.forEach((c) => {
          this.io.observe(c);
          this.preloadIO.observe(c);
        });
      }

      setState(card) {
        const v = card._v;
        card.dataset.playing = String(!v.paused && !v.ended);
        card.dataset.muted = String(v.muted);
        const playBtn = card.querySelector('[data-play]');
        const muteBtn = card.querySelector('[data-mute]');
        const bigBtn = card.querySelector('[data-bigplay]');
        if (playBtn) playBtn.setAttribute('aria-label', v.paused ? 'Play video' : 'Pause video');
        if (bigBtn) bigBtn.setAttribute('aria-label', 'Play video');
        if (muteBtn) {
          muteBtn.setAttribute('aria-label', v.muted ? 'Unmute video' : 'Mute video');
          muteBtn.setAttribute('aria-pressed', String(!v.muted));
        }
      }

      sync() {
        const vis = this.videoCards.filter((c) => this.visible.has(c));
        const target = this.activeCard && this.visible.has(this.activeCard) ? this.activeCard : vis[0];

        this.videoCards.forEach((card) => {
          const v = card._v;
          const isVisible = this.visible.has(card);
          const allowed = !this.opts.exclusive || card === target;

          if (!isVisible || !allowed) {
            if (!v.paused) this.pause(card, false);
            return;
          }
          if (this.opts.autoplayVideo && v.paused && !this.userPaused.has(card)) this.play(card);
        });
      }

      async play(card) {
        const v = card._v;
        v.muted = !this.soundOn;
        try {
          await v.play();
        } catch (err) {
          // Browsers block autoplay with sound until the visitor taps something
          if (!v.muted) {
            v.muted = true;
            this.soundOn = false;
            try {
              await v.play();
            } catch (e) {}
          }
        }
        if (!v.muted) this.muteOthers(card);
      }

      pause(card, byUser) {
        const v = card._v;
        v.pause();
        if (byUser) {
          this.userPaused.add(card);
        } else if (!this.opts.keepSound && !v.muted) {
          v.muted = true;
          this.soundOn = false;
        }
      }

      muteOthers(except) {
        this.videoCards.forEach((c) => {
          if (c !== except) c._v.muted = true;
        });
      }

      togglePlay(card) {
        const v = card._v;
        if (v.paused) {
          this.userPaused.delete(card);
          this.activeCard = card;
          this.play(card).then(() => this.opts.exclusive && this.sync());
        } else {
          this.pause(card, true);
        }
      }

      toggleMute(card) {
        const v = card._v;
        if (v.muted) {
          this.soundOn = true;
          v.muted = false;
          this.muteOthers(card);
          if (v.paused) {
            this.userPaused.delete(card);
            v.play().catch(() => {});
          }
        } else {
          v.muted = true;
          this.soundOn = false;
        }
      }

      /* ---------- Clicks + ripple ---------- */
      onClick(e) {
        if (this.opts.tapRipple) this.ripple(e);

        const card = e.target.closest('[data-card]');
        if (!card || !card._v) return;
        if (e.target.closest('a')) return;

        // The visitor is in control now, so stop the slider from moving on its own
        this.userControl = true;
        this.stopSliderAutoplay();

        if (e.target.closest('[data-mute]')) {
          this.toggleMute(card);
        } else if (e.target.closest('[data-play]') || e.target.closest('[data-bigplay]') || !e.target.closest('.vs-btn')) {
          this.togglePlay(card);
        }
      }

      ripple(e) {
        const btn = e.target.closest('.vs-btn');
        const host = btn
          ? btn.querySelector('.vs-btn__ripple')
          : e.target.closest('[data-card]')?.querySelector('.vs-card__ripple');
        if (!host) return;

        const r = host.getBoundingClientRect();
        const size = Math.max(r.width, r.height) * (btn ? 1.6 : 1.4);
        const keyboard = e.detail === 0;
        const x = keyboard ? r.width / 2 : e.clientX - r.left;
        const y = keyboard ? r.height / 2 : e.clientY - r.top;

        const dot = document.createElement('span');
        dot.className = 'vs-ripple';
        dot.style.width = dot.style.height = size + 'px';
        dot.style.left = x - size / 2 + 'px';
        dot.style.top = y - size / 2 + 'px';
        host.appendChild(dot);
        dot.addEventListener('animationend', () => dot.remove());
      }
    }

    customElements.define('video-slider-section', VideoSliderSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["whatsapp-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('wa-reviews-slider')) {
    class WaReviewsSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.controls = this.querySelector('[data-controls]');
        this.dotsEl = this.querySelector('[data-dots]');
        this.prevBtn = this.querySelector('[data-prev]');
        this.nextBtn = this.querySelector('[data-next]');
        if (!this.track) return;

        this.cards = Array.from(this.track.children);
        this.current = 0;
        this.timer = null;
        this.inView = true;
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.buildDots();
        this.bindEvents();
        this.update();
        this.setupAutoplay();
      }

      disconnectedCallback() {
        this.stopAutoplay();
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.viewObserver) this.viewObserver.disconnect();
        document.removeEventListener('visibilitychange', this.onVisibility);
      }

      get pad() {
        return parseFloat(getComputedStyle(this.track).paddingLeft) || 0;
      }

      buildDots() {
        this.dotsEl.innerHTML = '';
        this.dots = this.cards.map((_, i) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'wa-rev__dot';
          dot.setAttribute('aria-label', 'Go to message ' + (i + 1));
          dot.addEventListener('click', () => {
            this.goTo(i);
            this.restartAutoplay();
          });
          this.dotsEl.appendChild(dot);
          return dot;
        });
      }

      bindEvents() {
        let ticking = false;
        this.track.addEventListener(
          'scroll',
          () => {
            if (ticking) return;
            ticking = true;
            requestAnimationFrame(() => {
              this.update();
              ticking = false;
            });
          },
          { passive: true }
        );

        this.prevBtn?.addEventListener('click', () => {
          this.goTo(Math.max(this.current - 1, 0));
          this.restartAutoplay();
        });
        this.nextBtn?.addEventListener('click', () => {
          this.goTo(Math.min(this.current + 1, this.cards.length - 1));
          this.restartAutoplay();
        });

        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this.track);
      }

      goTo(index) {
        const card = this.cards[index];
        if (!card) return;
        this.track.scrollTo({ left: card.offsetLeft - this.pad, behavior: this.reduceMotion ? 'auto' : 'smooth' });
      }

      isAtEnd() {
        return this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 4;
      }

      update() {
        const scrollable = this.track.scrollWidth - this.track.clientWidth > 8;
        if (this.controls) this.controls.hidden = !scrollable;

        const left = this.track.scrollLeft;
        let idx = 0;
        if (this.isAtEnd() && scrollable) {
          idx = this.cards.length - 1;
        } else {
          let best = Infinity;
          const pad = this.pad;
          this.cards.forEach((card, i) => {
            const d = Math.abs(card.offsetLeft - pad - left);
            if (d < best) {
              best = d;
              idx = i;
            }
          });
        }
        this.current = idx;
        this.dots.forEach((dot, i) => {
          dot.setAttribute('aria-current', i === idx ? 'true' : 'false');
        });
        if (this.prevBtn) this.prevBtn.disabled = idx === 0;
        if (this.nextBtn) this.nextBtn.disabled = idx === this.cards.length - 1;
      }

      /* Autoplay */
      setupAutoplay() {
        this.autoplay = this.dataset.autoplay === 'true' && !this.reduceMotion && this.cards.length > 1;
        if (!this.autoplay) return;

        this.delay = Math.max(parseInt(this.dataset.delay, 10) || 4000, 2000);

        ['pointerenter', 'focusin', 'touchstart'].forEach((evt) =>
          this.addEventListener(evt, () => this.stopAutoplay(), { passive: true })
        );
        ['pointerleave', 'focusout', 'touchend'].forEach((evt) =>
          this.addEventListener(evt, () => this.restartAutoplay(), { passive: true })
        );

        this.onVisibility = () => (document.hidden ? this.stopAutoplay() : this.restartAutoplay());
        document.addEventListener('visibilitychange', this.onVisibility);

        this.viewObserver = new IntersectionObserver(
          ([entry]) => {
            this.inView = entry.isIntersecting;
            this.inView ? this.restartAutoplay() : this.stopAutoplay();
          },
          { threshold: 0.3 }
        );
        this.viewObserver.observe(this);

        this.startAutoplay();
      }

      startAutoplay() {
        if (!this.autoplay || this.timer || !this.inView) return;
        this.timer = setInterval(() => {
          if (this.isAtEnd()) {
            this.goTo(0);
          } else {
            this.goTo(this.current + 1);
          }
        }, this.delay);
      }

      stopAutoplay() {
        clearInterval(this.timer);
        this.timer = null;
      }

      restartAutoplay() {
        this.stopAutoplay();
        this.startAutoplay();
      }
    }

    customElements.define('wa-reviews-slider', WaReviewsSlider);
  }

  } catch(e) { console.error(e); }
})();
})();
